import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from 'antd';
import type { CargoRes } from 'api/swagger';
import { calculateCostPerItem } from 'shared/utils/cargos/calculate-cost-per-item';
import { countTotalPallets } from 'shared/utils/cargos/count-total-pallets';
import styles from './cargo-onfo-col.module.scss';

interface ICargoInfoColProps {
  cargo: CargoRes;
}

export const CargoInfoCol: React.FC<ICargoInfoColProps> = ({ cargo }) => {
  const { t } = useTranslation('common');

  const total = countTotalPallets(cargo);

  const costPerItem = calculateCostPerItem(cargo);

  return (
    <div>
      <Typography.Text className={styles.totalInfo}>
        {t('LDM')}: {cargo.totalLDM}
      </Typography.Text>
      <Typography.Text className={styles.totalInfo}>
        {t('volume')}: {cargo.totalVolume}
      </Typography.Text>
      <Typography.Text className={styles.totalInfo}>
        {t('weight')}: {cargo.totalWeight} / {cargo.calculatedTotalWeight}
      </Typography.Text>
      <Typography.Text className={styles.totalInfo}>
        {t('pallets')}: {total}
      </Typography.Text>
      {costPerItem ? <Typography.Text className={styles.totalInfo}>{costPerItem}</Typography.Text> : null}
    </div>
  );
};
